import { GenericAlarm } from '../../models/generic-alarm';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { GenericAlarmBuilder } from '../../models/builders/generic-alarm.builder';
import { GenericAlarmFormatBuilder } from '../../models/builders/generic-alarm-format.builder';

const genericAlarmBody = (genericAlarm: GenericAlarm) => ({
  active: genericAlarm.active,
  format: genericAlarm.format,
  dateRegex: genericAlarm.dateRegex,
  genericTxt: genericAlarm.genericTxt,
  controlHash: genericAlarm.control
});

@Injectable()
export class GenericAlarmApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }generic-alarms`;
  }

  createGenericAlarm(genericAlarm) {
    return this.httpClient.post(this.apiUrl, genericAlarmBody(genericAlarm)).pipe(map(GenericAlarmBuilder.fromJson));
  }

  deleteGenericAlarm(genericAlarm: GenericAlarm) {
    return this.httpClient.delete(`${ this.apiUrl }/${ genericAlarm.hash }`);
  }

  getGenericAlarms() {
    return this.httpClient.get(`${ this.apiUrl }`).pipe(map(GenericAlarmBuilder.fromList));
  }

  getGenericAlarm(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`)
      .pipe(
        map(GenericAlarmBuilder.fromJson)
      );
  }

  getGenericAlarmFormats() {
    return this.httpClient.get(`${ this.apiUrl }/formats`)
      .pipe(
        map(GenericAlarmFormatBuilder.fromList)
      );
  }

  updateGenericAlarm(genericAlarm: GenericAlarm) {
    return this.httpClient.put(`${ this.apiUrl }/${ genericAlarm.hash }`, genericAlarmBody(genericAlarm));
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/generic-alarm-api.service.ts